module.exports = __webpack_public_path__ + "img/success.df556a8d.png";